export const NoImage = ({ width, height }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height}>
    <text x="50%" y="50%" dominantBaseline="middle" textAnchor="middle" fill="grey">{width}x{height}</text>
  </svg>
);
